import { useCallback, useRef } from 'react';

/**
 * Focus return for a Radix Dialog or AlertDialog opened from state, with no
 * Trigger (#496). On close, Radix's modal content cancels FocusScope's own
 * focus return and focuses the dialog's trigger instead; with no trigger,
 * focus falls to <body> and keyboard users lose their place.
 *
 * Call `capture()` just before opening, and pass `onCloseAutoFocus` to the
 * dialog's content: focus goes back to the element that had it, while that
 * element is still in the document.
 */
export default function useReturnFocus() {
    const returnTo = useRef(null);

    const capture = useCallback(() => {
        returnTo.current = document.activeElement;
    }, []);

    const onCloseAutoFocus = useCallback((event) => {
        const target = returnTo.current;
        returnTo.current = null;
        event.preventDefault();
        if (target && target !== document.body && target.isConnected && typeof target.focus === 'function') {
            target.focus();
        }
    }, []);

    return { capture, onCloseAutoFocus };
}
